/*
 *
 * File: constants.js
 *
 * Purpose: App wide constants.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  18.03.2022
 * Modified: 24.04.2023
 *           - minimum length for password (MIN_PASSWORD_LENGTH)
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

//----------------------------------------------------------------------
//--- Constants for "tblAddTariffs" table columns
//----------------------------------------------------------------------
export const PACKAGE_NAME_POSTCODES                                    = "Streckenpreise mit Postleitzahlen";          // Parent product package
export const PACKAGE_NAME_STRECKENPREISOPTIMIERUNG                     = "Streckenpreisoptimierung";                   // Parent product package
export const SUBFEATURE_NAME_RUNDUNG_STRECKENPREISE                    = "Rundung Streckenpreise";                     // Subfeature of "parent Streckenpreisoptimierung"
export const SUBFEATURE_NAME_STRECKENAUSWAHL                           = "Streckenauswahl";                            // Subfeature of "parent Streckenpreisoptimierung"
export const SUBFEATURE_NAME_FAHRTSTECKE_MIT_UNTERSCHIEDLICHEN_TARIFEN = "Fahrtstrecke mit unterschiedlichen Tarifen"; // Is a subfeature of "Streckenpreisoptimierung"

export const VALUE_STRECKENAUSWAHL_SCHMNELLSTE                         = "Schnellste";
export const VALUE_STRECKENAUSWAHL_KUERZESTE                           = "Kuerzeste";
export const VALUE_RUNDUNG_STRECKENPREISE_NICHT_RUNDEN                 = "Nicht runden";
export const VALUE_RUNDUNG_STRECKENPREISE_AUFRUNDEN                    = "Aufrunden";
export const VALUE_RUNDUNG_STRECKENPREISE_ABRUNDEN                     = "Abrunden";

export const LIMOUSINE_BUSINESS                                        = "Limousine Business";
export const LIMOUSINE_FIRSTCLASS                                      = "Limousine First Class";
export const BUSINESS_VAN                                              = "Business Van";
export const BUS_XL                                                    = "Bus XL";

// Minimum length for password
export const MIN_PASSWORD_LENGTH                                       = 8;

// Send data to server result info box action codes
export const INFO_BOX_WAIT_CIRCLE                                      = "wait_circle";
export const INFO_BOX_RESULT_SUCCESS                                   = "result_success";
export const INFO_BOX_EMPTY                                            = "infoBox_empty";
export const INFO_BOX_RESULT_ERROR                                     = "result_error";
export const INFO_BOX_RESULT_USER_EXIST_ERROR                          = "result_error_user_exist";
export const INFO_BOX_RESULT_EMAIL_EXIST_ERROR                         = "result_error_email_exist";

// Payment
export const PAYMENT_CREDIT_CARD                                       = "Credit card";
export const PAYMENT_ON_COMPANY_BILL                                   = "On Company Bill";
export const PAYMENT_CASH                                              = "Cash";

// Payment methods
export const PAYMENT_METHOD_ON_DRIVER                                  = "onDriver";
export const PAYMENT_METHOD_CREDIT_CARD                                = "creditCard";
